import { httpGet, httpPut } from '../../../../Util/http';
import { addAlert } from '../../../../MsgNotify/msgNotifyActions';


export const UPDATE_CONTROL_AREA = 'UPDATE_CONTROL_AREA'
export const updateControlArea = (typeOf, index, value) => (
    {
        type: UPDATE_CONTROL_AREA,
        typeOf,
        index,
        value
    }
)

export const ADD_CONTROL_AREA = 'ADD_CONTROL_AREA'
export const addControlArea = () => (
    {
        type: ADD_CONTROL_AREA,
        controlArea: {
            area: "",
            type: "",
            temp: 0,
            crack: 0,
            control: 0,
            rf: 0,
            mpa: 0,
        }
    }
)


export function attemptSaveControlAreas(currentDailyReportId, getState, dispatch) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/controlarea/register'
    let controlAreas = getState().dailyReportControlAreaReducer.controlAreas;
    let controlAreasToSave = filterSaveAbleDeliveryNotes(controlAreas);
    return httpPut(_url, { id: currentDailyReportId, controlAreas: controlAreasToSave })
        .catch(() => {
            dispatch(addAlert("Kunne ikke gemme kontrol"))
            throw new Error("Kunne ikke gemme kontrol")
        })
}


function filterSaveAbleDeliveryNotes(controlAreas) {
    let result = [];
    controlAreas.forEach((d) => {
        if (d.Type || d.temp > 0 || d.crack > 0 || d.control > 0 || d.rf > 0 || d.mpa > 0 || d.area) {
            result.push(d);
        }
    })
    return result;
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/ControlArea/actions.js